import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';

@Injectable()
export class Broadcaster {
  public updateEditedLead: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public leadProfileInfo: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public leadList: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public contactsUpload: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public cachedNewPropertyData: BehaviorSubject<any> = new BehaviorSubject<any>(
    {},
  );
  public savedOptions: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public savedOptionsLicenses: BehaviorSubject<any> = new BehaviorSubject<any>(
    {},
  );
  public savedChosenProperties: BehaviorSubject<any> = new BehaviorSubject<any>(
    {},
  );
  public licenseGranted: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public cachedOffMarketLocations: BehaviorSubject<any> = new BehaviorSubject<any>(
    [],
  );
  public ownersList: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public ownersListData: any;
  public activePopup: any;

  public updateLead(lead): void {
    this.updateEditedLead.next(lead);
  }

  /**
   * set the value of the lead profile info subject
   * @param lead
   */
  public setLeadProfileInfo(lead): void {
    this.leadProfileInfo.next(lead);
  }

  /**
   * set the value of the lead list
   * @param leads
   */
  public setLeadList(leads): void {
    this.leadList.next(leads);
  }

  /**
   * set the value of the lead list
   * @param uploadedLeads
   */
  public uploadAgentContacts(uploadedLeads): void {
    this.contactsUpload.next(uploadedLeads);
  }

  /**
   * @description set a new value for the new property form cached info
   * @param data
   */
  public setCachedNewPropertyData(data) {
    this.cachedNewPropertyData.next(data);
  }

  /**
   * @description reset the cached new property data for the add new property form
   * this method is used to delete the cache
   */
  public resetCachedNewPropertyData() {
    this.cachedNewPropertyData.next({});
  }

  /**
   * @description set a new value for the locations in marketplace cached info
   * @param data
   */
  public setCachedOffMarketLocations(data) {
    this.cachedOffMarketLocations.next(data);
  }

  /**
   * @description save the already grouped contacts
   * @param data
   */
  public saveFilteredOptions(data) {
    this.savedOptions.next(data);
  }

  /**
   * @description save the already licensed contacts
   * @param data
   */
  public saveFilteredOptionsLicenses(data) {
    this.savedOptionsLicenses.next(data);
  }

  /**
   * @description save the already chosen properties
   * @param data
   */
  public saveChosenProperties(data) {
    this.savedChosenProperties.next(data);
  }

  /**
   * @description license grant click fired
   * @param data
   */
  public licenseGranting(data) {
    this.licenseGranted.next(data);
  }

  public setOwnersListData(data) {
    this.ownersList.next(data);
    this.ownersListData = data;
  }

  public activatePopup(popup): void {
    this.activePopup = popup;
  }
}
